export default __webpack_public_path__ + "static/content-bf23ce8c6e6ed29856d1a5e318aed34b.jpg";